export default "__VITE_ASSET__CPEWZVrv__"